import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined, SafetyOutlined, LockOutlined } from '@ant-design/icons';
import { CognitoUser } from "amazon-cognito-identity-js";
import { useLocation, useNavigate } from 'react-router-dom';
import UserPool from "../../utils/userPool";
import useTranslation from "../../hooks/useTranslation";

const { Title } = Typography;

const ResetPasswordPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    // Получение email из location.state
    const email = location.state?.email;

    if (!email) {
        message.error(t('auth.emailMissing'));
        navigate('/forgot-password');
        return null;
    }

    const onFinish = (values) => {
        const { code, newPassword, confirmPassword } = values;

        if (newPassword !== confirmPassword) {
            message.error(t('auth.passwordsMismatch'));
            return;
        }

        setLoading(true);

        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });

        user.confirmPassword(code, newPassword, {
            onSuccess: () => {
                message.success(t('auth.resetSuccess'));
                navigate('/login'); // Переход на страницу логина
            },
            onFailure: (err) => {
                message.error(t('auth.resetFailed', { message: err.message }));
            },
        });

        setLoading(false);
    };

    return (
        <div style={{ maxWidth: 400, margin: 'auto', padding: '2rem' }}>
            <Title level={3} style={{ textAlign: 'center' }}>{t('auth.resetPasswordTitle')}</Title>
            <Form onFinish={onFinish} layout="vertical">
                <Form.Item>
                    <Input
                        prefix={<MailOutlined />}
                        value={email}
                        readOnly
                    />
                </Form.Item>
                <Form.Item
                    name="code"
                    rules={[{ required: true, message: t('auth.verificationCodeRequired') }]}
                >
                    <Input
                        prefix={<SafetyOutlined />}
                        placeholder={t('auth.verificationCode')}
                    />
                </Form.Item>
                <Form.Item
                    name="newPassword"
                    rules={[
                        { required: true, message: t('auth.newPasswordRequired') },
                        { min: 8, message: t('auth.passwordTooShort') },
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('auth.newPassword')}
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    rules={[
                        { required: true, message: t('auth.confirmNewPasswordRequired') },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(t('auth.passwordsMismatch'));
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('auth.confirmNewPassword')}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block loading={loading}>
                        {t('auth.resetPassword')}
                    </Button>
                </Form.Item>
                <Button type="text" block onClick={() => navigate('/login')}>
                    {t('auth.backToLogin')}
                </Button>
            </Form>
        </div>
    );
};

export default ResetPasswordPage;
